import type { ScriptDescriptor } from '@hyphengroup/cms-components/utils/loadScriptOnce';

export const YOUTUBE_SCRIPT: ScriptDescriptor = {
  id: 'youtube-iframe-api',
  src: 'https://www.youtube.com/iframe_api',
};
